import React, { Component } from "react";
import { Link } from "react-router-dom";
import Content from "../../content/Content";
import { Paths, Urls } from "../../constants/UrlConstants";
import linkStyles from "../../assets/css/modules/shared/link.css";

export default class SmallFooterMenuItem extends Component {
  constructor() {
    super();
    this.state = {
      isOpen: false
    };
  }
  handleClick(e) {
    e.preventDefault();
    this.setState({
      isOpen: !this.state.isOpen
    });
    return false;
  }
  render() {
    this.handleClick = this.handleClick.bind(this);
    return (
      <li key={this.props.footerMenuCtr}>
        <button
          className={this.state.isOpen ? "" : "collapsed"}
          onClick={this.handleClick}
        >
          <Content name={this.props.footerMenu.Heading} />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={9}
            viewBox="0 0 16 9"
            className="drop"
          >
            <path
              fill="none"
              fillRule="evenodd"
              stroke="#FFF"
              strokeLinecap="round"
              strokeWidth={2}
              d="M0 0l8 8 8-8"
            />
          </svg>
        </button>
        <ul className={this.state.isOpen ? "" : "collapse"}>
          {this.props.footerMenu.Links.map((footerLink, footerLinkCtr) => {
            if (
              (!this.props.isHOL &&
                !this.props.isInternational &&
                  !this.props.isSaga &&
                  !this.props.isLapsed) ||
              (this.props.isInternational &&
                Paths.GPAppointments247 !== footerLink.Link &&
                  Paths.HealthInformation !== footerLink.Link) ||
              (this.props.isSaga &&
                Paths.GPAppointments247 !== footerLink.Link) ||
              (this.props.isLapsed &&
                Paths.GPAppointments247 !== footerLink.Link) ||
              (this.props.isHOL && Paths.GPAppointments247 !== footerLink.Link)
            ) {
              let helpLink = "";
              if (footerLink.Link === Paths.Help) {
                helpLink = "?area=" + this.props.pageArea;
              }
              if (footerLink.Link === Urls.AccessibilityUrl) {
                return (
                  <li className="footer-link-item" key={footerLinkCtr}>
                    <a
                      href={footerLink.Link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="footer-link footer-link-small"
                    >
                      {footerLink.Text}
                    </a>
                  </li>
                );
              } 
              else if(this.props.featureFlagEP === true && footerLink.Link === Paths.Inbox){
                if(this.props.IsInternalView)
                  {
                      return (<Link to="/" className={linkStyles.disabled} onClick={ (event) => event.preventDefault() }>{footerLink.Text}</Link>);
                  }
                  else{
                      return (
                      <li className="footer-link-item" key={footerLinkCtr}>
                        <a
                          href={this.props.urlInbox}
                          target="_blank"
                          rel="noopener"
                          className="footer-link"
                        >
                          {footerLink.Text}
                        </a>
                      </li>
                      );
                    }
              } else {
                return (
                  <li key={footerLinkCtr}>
                    <Link
                      to={footerLink.Link + helpLink}
                      className="footer-link"
                    >
                      <Content name={footerLink.Text} />
                    </Link>
                  </li>
                );
              }
            }
            return null;
          })}
        </ul>
      </li>
    );
  }
}
